import React from "react";

export default function FaqSidebar({ categories, active, onSelect }) {
  return (
    <div className="faq-sidebar">
      <h6>Table of Content</h6>
      {categories.map((c) => (
        <button
          key={c}
          type="button"
          className={`faq-toc-link ${active === c ? "active" : ""}`}
          onClick={() => onSelect(c)}
        >
          {c}
        </button>
      ))}
    </div>
  );
}
